import { z } from "zod";
import { TObjectBase } from "../base";
import { TRawDeviation } from "./task";
import { TFirebaseTimestamp, TTaskVisibility } from "../deprecated";
import { TTaskInvoicedTo } from "./taskInvoice";
import { UploadFilesRequest } from "../file/apiFile";
import { TReadAccess } from "../common/readAccess";
import { TReference, TRelatives } from "../common/relative";

export const TApiTaskUpdate = TRawDeviation.extend({
  filesToUpload: UploadFilesRequest,
});

export type IApiTaskUpdate = z.infer<typeof TApiTaskUpdate>;

/** @deprecated use TRawTaskUpdate instead */
export const TRawDeviationUpdate = z
  .object({
    userID: z.string().optional(),
    date: TFirebaseTimestamp.optional(),
    skipNotifications: z.boolean().optional(),
    comment: z.string().optional(),

    oldProperties: TRawDeviation.partial().optional(),
    newProperties: TRawDeviation.partial().optional(),

    readAccess: TReadAccess.optional(),
    seenBy: TRawDeviation.shape.seenBy.optional(),

    //These fields are needed for external users.
    //These fields are not redundant in the case of normal users, we want to store the user information in case the original user is deleted.
    senderName: z.string().optional(),
    senderRole: z.string().optional(),
    senderEmail: z.string().optional(),
    senderPhone: z.string().optional(),

    //The following fields are a mirror of the deviation object
    invoicedTo: TTaskInvoicedTo.nullish(),
    updatedVisibility: TTaskVisibility.optional(),
    unitIDs: TRawDeviation.shape.unitIDs.optional(),
    status: TRawDeviation.shape.status.optional(),
    priority: TRawDeviation.shape.priority.optional(),
    archived: TRawDeviation.shape.archived.optional(),
    contractorGroups: TRawDeviation.shape.contractorGroups.optional(),
    responsibles: TRawDeviation.shape.responsibles.optional(),
    executors: TRawDeviation.shape.executors.optional(),
    floors: TRawDeviation.shape.floors.optional(),
    placeDescription: TRawDeviation.shape.placeDescription.optional(),
    startDate: TRawDeviation.shape.startDate.optional(),
    deadline: TRawDeviation.shape.deadline.optional(),
    category: TRawDeviation.shape.category.optional(),
    tags: TRawDeviation.shape.tags.optional(),
    files: TRawDeviation.shape.files.optional(),

    //Deprecated fields
    /** @deprecated use unitIDs instead */
    units: z.array(z.string()).optional(),
    /** @deprecated use newTaskTypeID instead */
    newType: z.string().optional(),
    /** @deprecated use oldTaskTypeID instead */
    oldType: z.string().optional(),
    /** @deprecated use newTaskTypeID instead */
    newCustomTaskType: TReference.optional(),
    /** @deprecated use oldTaskTypeID instead */
    oldCustomTaskType: TReference.optional(),

    //Added and removed data
    addedRelatives: TRelatives.optional(),
    removedRelatives: TRelatives.optional(),
    addedContractorGroups: TRawDeviation.shape.contractorGroups.optional(),
    removedContractorGroups: TRawDeviation.shape.contractorGroups.optional(),
    addedResponsibles: TRawDeviation.shape.responsibles.optional(),
    removedResponsibles: TRawDeviation.shape.responsibles.optional(),
    addedExecutors: TRawDeviation.shape.executors.optional(),
    removedExecutors: TRawDeviation.shape.executors.optional(),

    //Old and new data
    newTitle: z.string().optional(),
    oldTitle: z.string().optional(),
    newDescription: z.string().optional(),
    oldDescription: z.string().optional(),
    newTaskTypeID: z.string().optional(),
    oldTaskTypeID: z.string().optional(),
  })
  .extend(TObjectBase.shape);

/** @deprecated use IRawTaskUpdate instead */
export type IRawDeviationUpdate = z.infer<typeof TRawDeviationUpdate>;

export const TRawTaskUpdate = TRawDeviationUpdate;
export type IRawTaskUpdate = IRawDeviationUpdate;
